import { render, staticRenderFns } from "./AreaSetDrawer.vue?vue&type=template&id=c8159068&scoped=true&"
import script from "./AreaSetDrawer.vue?vue&type=script&lang=js&"
export * from "./AreaSetDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AreaSetDrawer.vue?vue&type=style&index=0&id=c8159068&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8159068",
  null
  
)

export default component.exports